<h1 mat-dialog-title>Do you want to continue?</h1>
<div mat-dialog-content>
    <p>If you press ok, you will to loose the existing criteria. If you don't want this, press Cancel.</p>
</div>
<div mat-dialog-actions>
    <button mat-button (click)="ok()" cdkFocusInitial>Ok</button>
    <button mat-button (click)="cancel()">No Thanks</button>
</div>